export const sanitizeAadhaarNumber = (value = "") =>
  value.toString().replace(/\D/g, "").slice(0, 12);

export const formatAadhaarNumber = (value = "") => {
  const cleanValue = sanitizeAadhaarNumber(value);

  return cleanValue.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
};
